import AbstractView from "../../../../../shared/src/ranj/equalture/view/AbstractView";

export default class HudView extends AbstractView {
    constructor(target, languagePack) {
        super(target);
        this._languagePack = languagePack;

        this._levelTextfield = this._target.levelTextfield;

        this._target.levelLabelTextfield.text = this.getText("hud.level.label");
    }

    setLevel(idx, total) {
        let str = this.getText("hud.level", { CURRENT: idx, TOTAL: total });
        this._levelTextfield.text = str;
    }
}